export class ApiError<T = unknown> extends Error {
  constructor(
    public message: string,
    public status: number,
    public payload?: T,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export const isApiError = (e: unknown): e is ApiError =>
  !!e && typeof e === 'object' && 'status' in e;

export const safeJson = async (res: Response) => {
  try {
    return await res.json();
  } catch {
    return null;
  }
};
